import React from 'react';

function ProgressBar({ progress }) {
  return (
    <div className="w-full bg-gray-200 rounded-full h-4">
      <div
        className="bg-[rgb(130,88,18)] h-4 rounded-full"
        style={{ width: `${Math.max(0, Math.min(100, Number.isFinite(progress) ? progress : 0))}%` }}
      ></div>
    </div>
  );
}

export default ProgressBar;